import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { ClaimsRoutingModule } from './claims-routing.module';
import { ClaimsComponent } from './claims.component';
import { ClaimEditComponent } from './claim-edit/claim-edit.component';
import { ClaimListComponent } from './claim-list/claim-list.component';
import { ViewbatchComponent } from './viewbatch/viewbatch.component';
import { OperationalDashboardService } from '../operational-dashboard/operational-dashboard.service';
import { VerificationsModule } from '../verifications/verifications.module';

@NgModule({
  declarations: [ClaimsComponent, ClaimEditComponent, ClaimListComponent, ViewbatchComponent,],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    MyDatePickerModule,
    ClaimsRoutingModule,
    VerificationsModule
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService, OperationalDashboardService],
})
export class ClaimsModule { }
